import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-boton-flotante',
  templateUrl: './boton-flotante.component.html',
  styleUrls: ['./boton-flotante.component.scss']
})
export class BotonFlotanteComponent {

  @Input("icono") icono: string = "vectors60225821.svg"
  icono2: string = "vectors84112899.svg"

  obtenerIconoAsistente() {
    return 'assets/images/' + this.icono2;
  }

}
